<template>
  <div class="image-grid">
    <img v-for="(image, index) in images" :key="index" :src="image" @click="$emit('selected', index)">
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import MediaDetector from '@/utils/MediaDetector'

@Component({
  mixins: [
    MediaDetector,
  ],
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
})
export default class ImageGrid extends Vue {
}
</script>

<style lang="scss">
  .image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    grid-auto-rows: 145px;
    grid-auto-flow: dense;
    grid-column-gap: 30px;
    grid-row-gap: 30px;

    @include media(tablet) {
      grid-template-columns: repeat(3, minmax(220px, 1fr));
    }

    @include media(desktop) {
      grid-template-columns: repeat(5, minmax(220px, 1fr));
    }

    img {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/offers-list/ImageGrid.vue